import { render, staticRenderFns } from "./detailTable3.vue?vue&type=template&id=3d849d52&scoped=true"
import script from "./detailTable3.vue?vue&type=script&lang=js"
export * from "./detailTable3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d849d52",
  null
  
)

export default component.exports